import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';

import HardwareModel from '../models/HardwareModel';

class HardwareSection extends React.Component {
    load = async () => {
        try {
            this.props.callbackFromParent(this.model);
        } catch (err) {
            console.error('HardwareSection:' + err);
        }
    };

    componentWillMount() {
        const { session } = this.props.session;
        this.model = new HardwareModel(session);
        this.model.load();
    }

    componentDidMount() {
        this.interval = setInterval(this.load, 250);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const modelHard = this.model;

        return (
            <Section title="Hardware">
                <List>
                    <Row>
                        <Label>MAC Address</Label>
                        <Value>{modelHard.macaddr}</Value>
                    </Row>
                    <Row>
                        <Label>Hardware Type</Label>
                        <Value>{modelHard.hardwaretype}</Value>
                    </Row>
                    <Row>
                        <Label>IPAM Type</Label>
                        <Value>{modelHard.ipamtype}</Value>
                    </Row>
                    <Row>
                        <Label>MicroSD Used/Size</Label>
                        <Value>
                            {modelHard.sdused} / {modelHard.sdsize} (
                            {modelHard.sdusedpercent})
                        </Value>
                    </Row>
                    <Row>
                        <Label>MicroSD File System</Label>
                        <Value>{modelHard.filesystem}</Value>
                    </Row>
                    <Row>
                        <Label>MicroSD FS Status</Label>
                        <Value>{modelHard.fsstatus}</Value>
                    </Row>
                </List>
            </Section>
        );
    }
}

export default observer(HardwareSection);



// WEBPACK FOOTER //
// ./src/sections/Hardware.js